module.exports = {
  realm: 'FC',
  market: 'fr-CA',
  domain: 'fr.weightwatchers.ca',
  countryId: '2000',
  vsPath: 'ca/fr',
  spiceLocale: 'fc',
  vsUrl: 'https://www{env}weightwatchers.com/ca/fr',
  spiceUrl: 'https://www{env}weightwatchers.com/assets/cmx/fc/messages/',
  cmxSiteUrl: 'https://cmx{env}fr.weightwatchers.ca/',
  currency: '$ C',
  decimalSeparator: '.',
  thousandSeparator: ' ',
  currencyFormat: '%number $ C',
  useZipCodeForEligibleOffers: true,
  dateFormat: 'dd/MM/yyyy',
  loginApiUrl: 'https://auth{env}fr.weightwatchers.ca/login-apis/',
  loginWebUrl: 'https://auth{env}fr.weightwatchers.ca/v2/login/',
  countryCode: 'CA',
  commUlr: 'https://commerce{env}weightwatchers.com/ca/fr/api/',
  timezone1: 'America/Toronto',
  timezone2: '-05:00',
};
